
import { Input, Injectable, OnInit, Output, EventEmitter, Directive } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Configuration } from '../../../conf/app.constants';
import { PlycaDataService } from '../../../../services/plyca.service';
import { CommunicationEditionModel } from '../communication.edition.component';
import { CommunicationAgentDTO, CommunicationDirectionType } from '../../../api/plyca-dtos-v2';
import { ServiceLocator } from '../../../ServiceLocator';
import { UIService } from '../../../ui.service';
import { AbstractControl } from '@angular/forms';
import { BaseComponent } from '../../../components/common/baseComponent/base.component';
import { DialogService } from 'primeng-lts/dynamicdialog';

export class ChipElement {
  name: string;
  value: CommunicationAgentDTO;
}

@Directive()
@Injectable()
export class CommunicationBaseFieldComponent extends BaseComponent implements OnInit {

  @Input()
  public model: CommunicationEditionModel;
  @Input()
  public formPlycaGroup: AbstractControl;
  @Output()
  editDialogOpened = new EventEmitter<boolean>();

  public editable = true

  protected translateService: TranslateService;
  protected configuration: Configuration;
  protected dialogService: DialogService;
  protected plycaService: PlycaDataService;
  protected uiService: UIService;

  constructor() {
    super();
    this.translateService = ServiceLocator.injector.get(TranslateService);
    this.configuration = ServiceLocator.injector.get(Configuration);
    this.dialogService = ServiceLocator.injector.get(DialogService);
    this.plycaService = ServiceLocator.injector.get(PlycaDataService);
    this.uiService = ServiceLocator.injector.get(UIService);
  }

  ngOnInit(): void {
    this.editable = this.model.ui.edition && (!this.model.dto.direction ||
      this.model.dto.direction === CommunicationDirectionType.OUT);
  }

  // metodos de utilidad
  public getAgentDescription(sender: CommunicationAgentDTO): string {
    return CommunicationAgentDTO.getAgentDescription(sender);
  }

  public setFocusToElement(event: Event, elementId: string) {
    if (this.model.ui.edition) {
      let button = document.getElementById(elementId);
      if (button) {
        button.focus();
      }
    }
    return this.uiService.cancelEvent(event);
  }

}